import { cn } from "@ui/utils"

interface MaskedIconProps {
  src: string
  className?: string
}

export function MaskedIcon({ src, className }: MaskedIconProps) {
  return (
    <div
      className={cn("text-icon size-4", className)}
      style={{
        maskImage: `url('${src}')`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        WebkitMaskImage: `url('${src}')`,
        WebkitMaskSize: "contain",
        WebkitMaskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        backgroundColor: "currentColor",
      }}
    />
  )
}
